"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preparePOTtoFirestore = exports.generateId = exports.dataToObject = exports.convertDateTime = exports.byString = exports.count = exports.firestoreTimestampToDate = exports.removeNull = exports.removeUndefined = exports.updatesToFirestoreUpdates = exports.buildCustomDiff = exports.diffObjectPrev = exports.diffObject = exports.isFirebaseGeoPoint = exports.getTimeFirebaseTimestamp = exports.isFirebaseTimestamp = exports.isDate = exports.isObject = exports.isArray = void 0;
exports.deepCopy = deepCopy;
// import deepEqual from "deep-equal";
const firestore_1 = require("firebase/firestore");
const jsonPatch = require("fast-json-patch");
const _ = require("lodash");
const numberInPathRegex = /[0-9]+/g;
const extractPathRegex = /[A-Za-z0-9äÄöÖüÜß]+/g;
const isArrayIndicator = (element) => numberInPathRegex.test(element);
const isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
};
exports.isArray = isArray;
const isObject = function (x) {
    return Object.prototype.toString.call(x) === '[object Object]';
};
exports.isObject = isObject;
const isValue = function (x) {
    return !(0, exports.isObject)(x) && !(0, exports.isArray)(x);
};
const isDate = function (x) {
    return Object.prototype.toString.call(x) === '[object Date]';
};
exports.isDate = isDate;
const isFirebaseTimestamp = function (x) {
    if (!x)
        return false;
    return (Object.keys(x).includes('seconds') && Object.keys(x).includes('nanoseconds')) || (Object.keys(x).includes('_seconds') && Object.keys(x).includes('_nanoseconds'));
};
exports.isFirebaseTimestamp = isFirebaseTimestamp;
const getTimeFirebaseTimestamp = function (element) {
    let dateValue;
    dateValue = element;
    if (element) {
        if (element['_nanoseconds'] || element['_seconds']) {
            const NS_TO_MS_MULTIPLIER = 1 / 1000000;
            const SEC_TO_MS_MULTIPLIER = 1000;
            const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER;
            const date = new Date(timestampInMilliseconds);
            element = date;
            dateValue = date.toUTCString();
        }
        if (element['nanoseconds'] || element['seconds']) {
            const NS_TO_MS_MULTIPLIER = 1 / 1000000;
            const SEC_TO_MS_MULTIPLIER = 1000;
            const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER;
            const date = new Date(timestampInMilliseconds);
            element = date;
            dateValue = date.toUTCString();
        }
        try {
            const newdate = new Date(element);
            if (newdate)
                dateValue = newdate.getTime();
        }
        catch (errro) { }
    }
    return dateValue;
};
exports.getTimeFirebaseTimestamp = getTimeFirebaseTimestamp;
const isFirebaseGeoPoint = function (x) {
    if (!x)
        return false;
    else
        return (x.latitude || x.longitude);
};
exports.isFirebaseGeoPoint = isFirebaseGeoPoint;
const diffObject = (oldObj, newObj, result) => {
    var _a;
    if (!newObj)
        newObj = {};
    if (oldObj == undefined && newObj) {
        if ((0, exports.isObject)(newObj)) {
            for (let [k, v] of Object.entries(newObj)) {
                result[k] = { oldValue: undefined, newValue: v };
            }
            return result;
        }
    }
    if (oldObj == undefined)
        return undefined;
    const oldKeys = Object.keys(oldObj);
    for (let [key, value] of Object.entries(newObj)) {
        if (oldKeys.includes(key) && !(0, exports.isObject)(value) && !(0, exports.isDate)(value) && !(0, exports.isFirebaseTimestamp)(value)) {
            // check euality.. 
            if ((0, exports.isArray)(oldObj[key])) { //*******added on 12.05 to check each value on array for checking differences*/
                const oldKey = oldObj[key];
                const newKey = value;
                if (oldKey && newKey) {
                    const maxLength = Math.max(oldKey.length, newKey.length);
                    const arrayDiff = [];
                    for (let i = 0; i < maxLength; i++) {
                        // ---- check obj inside array)
                        if ((0, exports.isObject)(newKey[i])) {
                            const map = (0, exports.diffObject)(oldObj[key], newKey[i], {});
                            // console.log('map',map)
                            if (map) {
                                for (let [k, v] of Object.entries(map)) {
                                    let r = v;
                                    const oldValue = oldKey[i] ? oldKey[i][k] : undefined;
                                    // if( oldValue != r.newValue )//prevent undefined oldValue, newValue
                                    // result[`${key}.${i}.${k}`] = v
                                    if (JSON.stringify(newKey[i]) !== JSON.stringify(oldKey[i]))
                                        arrayDiff.push({ position: i, newValue: newKey[i], oldValue: oldKey[i] });
                                    // arrayDiff.push({position: i, newValue: r.newValue, oldValue: oldValue});
                                    //         let val = v as any
                                    //         if( !oldObj[key][i] || !oldObj[key][i][k] ){
                                    //             // result[`${key}.${i}.${k}`] = {oldValue: undefined, newValue: val?.newValue}
                                    //             arrayDiff.push({
                                    //                 position: i,
                                    //                 newValue: newKey[i],
                                    //                 oldValue: oldKey[i]
                                    //             });
                                    //         }
                                    //         if( oldObj[key] && oldObj[key][i] && oldObj[key][i][k] !== val.newValue){
                                    //             // result[`${key}.${i}.${k}`] = {oldValue: oldObj[key][i][k] ? oldObj[key][i][k] : undefined, newValue: val?.newValue}
                                    //             arrayDiff.push({
                                    //                 position: i,
                                    //                 newValue: newKey[i],
                                    //                 oldValue: oldKey[i]
                                    //             });
                                    //         }
                                }
                            }
                            // console.log('result',result)
                        }
                        else {
                            if (oldKey[i] !== newKey[i]) {
                                arrayDiff.push({
                                    position: i,
                                    newValue: newKey[i],
                                    oldValue: oldKey[i]
                                });
                            }
                        }
                    }
                    // console.log('arrayDiff-----', arrayDiff)
                    if (((_a = Object.keys(arrayDiff)) === null || _a === void 0 ? void 0 : _a.length) != 0)
                        result[key] = { oldValue: oldObj[key], newValue: value };
                }
            }
            else {
                if (oldObj[key] == value)
                    continue;
                else {
                    result[key] = { oldValue: oldObj[key], newValue: value };
                }
            }
        }
        else if ((0, exports.isDate)(value)) {
            const oldDate = oldObj[key];
            const newDate = value;
            if ((newDate === null || newDate === void 0 ? void 0 : newDate.getTime()) == ((0, exports.isFirebaseTimestamp)(oldDate) ? (0, exports.getTimeFirebaseTimestamp)(oldDate) : oldDate === null || oldDate === void 0 ? void 0 : oldDate.getTime()))
                continue;
            else {
                result[key] = { oldValue: oldDate, newValue: newDate };
            }
        }
        else if ((0, exports.isFirebaseTimestamp)(value)) {
            if (value.seconds == oldObj[key].seconds)
                continue;
            else {
                result[key] = { oldValue: oldObj[key], newValue: value };
            }
        }
        else if ((0, exports.isFirebaseGeoPoint)(value)) {
            const oldLoc = oldObj[key];
            const newLoc = value;
            if (oldLoc === null || oldLoc === void 0 ? void 0 : oldLoc.isEqual(newLoc))
                continue;
            else {
                result[key] = { oldValue: oldObj[key], newValue: value };
            }
        }
        else if ((0, exports.isObject)(value)) {
            const map = (0, exports.diffObject)(oldObj[key], value, {});
            if (map) {
                for (let [k, v] of Object.entries(map)) {
                    let r = v;
                    if (r.oldValue != undefined || r.newValue != undefined) //prevent undefined oldValue, newValue
                        result[`${key}.${k}`] = v;
                }
            }
        }
        else {
            if (value == null || value == undefined || key == "className")
                continue;
            else if ((0, exports.isObject)(value)) {
                const map = (0, exports.diffObject)(undefined, value, {});
                if (map) {
                    for (let [k, v] of Object.entries(map)) {
                        result[`${key}.${k}`] = v;
                    }
                }
            }
            else
                result[key] = { oldValue: undefined, newValue: value };
        }
    }
    for (const [key, value] of Object.entries(oldObj)) { // delete fields that exist in oldObj but not in newObj
        if (!Object.prototype.hasOwnProperty.call(newObj, key))
            result[key] = { oldValue: oldObj[key], newValue: undefined };
    }
    return result;
};
exports.diffObject = diffObject;
const diffObjectPrev = (oldObj, newObj, result) => {
    var _a;
    if (!newObj)
        newObj = {};
    if (oldObj == undefined && newObj) {
        if ((0, exports.isObject)(newObj)) {
            for (let [k, v] of Object.entries(newObj)) {
                result[k] = { oldValue: undefined, newValue: v };
            }
            return result;
        }
    }
    if (oldObj == undefined)
        return undefined;
    const oldKeys = Object.keys(oldObj);
    for (let [key, value] of Object.entries(newObj)) {
        if (oldKeys.includes(key) && !(0, exports.isObject)(value) && !(0, exports.isDate)(value) && !(0, exports.isFirebaseTimestamp)(value)) {
            // check euality.. 
            if ((0, exports.isArray)(oldObj[key])) { //*******added on 12.05 to check each value on array for checking differences*/
                const oldKey = oldObj[key];
                const newKey = value;
                const maxLength = Math.max(oldKey.length, newKey.length);
                const arrayDiff = [];
                for (let i = 0; i < maxLength; i++) {
                    if (oldKey[i] !== newKey[i]) {
                        arrayDiff.push({
                            position: i,
                            newValue: newKey[i],
                            oldValue: oldKey[i]
                        });
                    }
                }
                if (((_a = Object.keys(arrayDiff)) === null || _a === void 0 ? void 0 : _a.length) != 0)
                    result[key] = { oldValue: oldObj[key], newValue: value };
            }
            else {
                if (oldObj[key] == value)
                    continue;
                else {
                    result[key] = { oldValue: oldObj[key], newValue: value };
                }
            }
        }
        else if ((0, exports.isDate)(value)) {
            const oldDate = oldObj[key];
            const newDate = value;
            if (newDate.getTime() == (oldDate === null || oldDate === void 0 ? void 0 : oldDate.getTime()))
                continue;
            else {
                result[key] = { oldValue: oldDate, newValue: newDate };
            }
        }
        else if ((0, exports.isFirebaseTimestamp)(value)) {
            if (value.seconds == oldObj[key].seconds)
                continue;
            else {
                result[key] = { oldValue: oldObj[key], newValue: value };
            }
        }
        else if ((0, exports.isFirebaseGeoPoint)(value)) {
            const oldLoc = oldObj[key];
            const newLoc = value;
            if (oldLoc === null || oldLoc === void 0 ? void 0 : oldLoc.isEqual(newLoc))
                continue;
            else {
                result[key] = { oldValue: oldObj[key], newValue: value };
            }
        }
        else if ((0, exports.isObject)(value)) {
            const map = (0, exports.diffObject)(oldObj[key], value, {});
            if (map) {
                for (let [k, v] of Object.entries(map)) {
                    result[`${key}.${k}`] = v;
                }
            }
        }
        else {
            if (value == null || value == undefined || key == "className")
                continue;
            else if ((0, exports.isObject)(value)) {
                const map = (0, exports.diffObject)(undefined, value, {});
                if (map) {
                    for (let [k, v] of Object.entries(map)) {
                        result[`${key}.${k}`] = v;
                    }
                }
            }
            else
                result[key] = { oldValue: undefined, newValue: value };
        }
    }
    for (const [key, value] of Object.entries(oldObj)) { // delete fields that exist in oldObj but not in newObj
        if (!Object.prototype.hasOwnProperty.call(newObj, key))
            result[key] = { oldValue: oldObj[key], newValue: undefined };
    }
    return result;
};
exports.diffObjectPrev = diffObjectPrev;
const buildCustomDiff = (oldObj, newObj) => {
    const diff = jsonPatch.compare(oldObj, newObj, true);
    const result = {};
    if (diff.length == 0)
        return result;
    for (let op of diff) {
        const pathParts = op.path.match(extractPathRegex);
        if (!pathParts)
            continue;
        const containsArrayAtPathIndex = pathParts.findIndex(isArrayIndicator);
        let path = null;
        let value = null;
        if (containsArrayAtPathIndex == -1) {
            // does not contain array
            path = pathParts.join('.');
        }
        else {
            // contains array
            const shortPathParts = pathParts.slice(0, containsArrayAtPathIndex);
            path = shortPathParts.join('.');
        }
        if (path.includes("updateTimestamp") || path.includes("creationDate"))
            continue;
        if (op.op == "test")
            value = _.get(oldObj, path);
        else
            value = _.get(newObj, path);
        if (!result[path])
            result[path] = { oldValue: undefined, newValue: undefined };
        switch (op.op) {
            case "add": {
                result[path].newValue = value;
                break;
            }
            case "copy": {
                console.warn("No action defined for copy", op);
                // probably not needed?
                break;
            }
            case "move": {
                console.warn("No action defined for move", op);
                break;
            }
            case "remove": {
                // not needed newValue already undefined
                break;
            }
            case "replace": {
                result[path].newValue = value;
                break;
            }
            case "test": {
                result[path].oldValue = value;
                break;
            }
        }
    }
    return result;
};
exports.buildCustomDiff = buildCustomDiff;
const updatesToFirestoreUpdates = (updates) => {
    let map = {};
    for (let [key, value] of Object.entries(updates)) {
        const { newValue } = value;
        map[key] = newValue ? newValue : (0, firestore_1.deleteField)();
    }
    // updates.forEach((value, key) => {
    //     const {newValue} = value
    //     map[key] = newValue ? newValue : firebase.default.firestore.FieldValue.delete()
    // })
    return map;
};
exports.updatesToFirestoreUpdates = updatesToFirestoreUpdates;
const removeUndefined = (obj) => {
    // console.log(obj)
    for (var propName in obj) {
        if ((0, exports.isArray)(obj[propName])) {
            let newArray = [];
            for (let o of obj[propName]) {
                newArray.push((0, exports.removeUndefined)(o));
            }
            obj[propName] = newArray;
        }
        else if ((0, exports.isObject)(obj[propName])) {
            obj[propName] = (0, exports.removeUndefined)(obj[propName]);
        }
        else if (obj[propName] === undefined || obj[propName] === null) {
            delete obj[propName];
        }
    }
    // console.log(obj)
    return obj;
};
exports.removeUndefined = removeUndefined;
const removeNull = (obj) => {
    // console.log(obj)
    for (var propName in obj) {
        if ((0, exports.isArray)(obj[propName])) {
            let newArray = [];
            for (let o of obj[propName]) {
                newArray.push((0, exports.removeNull)(o));
            }
            obj[propName] = newArray;
        }
        else if ((0, exports.isObject)(obj[propName])) {
            obj[propName] = (0, exports.removeNull)(obj[propName]);
        }
        else if (obj[propName] === null) {
            delete obj[propName];
        }
    }
    // console.log(obj)
    return obj;
};
exports.removeNull = removeNull;
const firestoreTimestampToDate = (timestamp) => {
    if (!timestamp)
        return undefined;
    else if (timestamp._seconds)
        return new Date(timestamp._seconds * 1000);
    else
        return new Date(timestamp.seconds * 1000);
};
exports.firestoreTimestampToDate = firestoreTimestampToDate;
function deepCopy(obj, replacerFn) {
    var copy;
    if (null == obj || "object" != typeof obj)
        return obj;
    // Handle Date
    if ((0, exports.isFirebaseGeoPoint)(obj)) {
        // console.log("deep copy location coordinate")
        const copy = new firestore_1.GeoPoint(obj.latitude, obj.longitude);
        return copy;
    }
    if (obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }
    // Handle Array
    if (obj instanceof Array) {
        copy = [];
        for (var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepCopy(obj[i]);
        }
        return copy;
    }
    // Handle Object
    if (obj instanceof Object) {
        copy = {};
        for (var attr in obj) {
            if (obj.hasOwnProperty(attr)) {
                // replacerFn if exists should return true for values to be included, 
                // false for values to be skipped 
                if (replacerFn) {
                    if (replacerFn(attr)) {
                        copy[attr] = deepCopy(obj[attr]);
                    }
                    else {
                        continue;
                    }
                }
                else
                    copy[attr] = deepCopy(obj[attr]);
            }
        }
        return copy;
    }
    throw new Error("Unable to copy obj! Its type isn't supported.");
}
const skipDeepCopy = Symbol('skipDeepCopy');
const count = (arr, condition) => arr.reduce((acc, c) => condition(c) ? ++acc : acc, 0);
exports.count = count;
const byString = (o, s) => {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, ''); // strip a leading dot
    var a = s.split('.');
    for (var i = 0, n = a.length; i < n; ++i) {
        var k = a[i];
        if (!o) {
            return null;
        }
        else {
            if (k in o) {
                o = o[k];
            }
            else {
                return null;
            }
        }
    }
    return o;
};
exports.byString = byString;
const convertDateTime = function (element) {
    let dateValue;
    dateValue = element;
    if (element) {
        if (element['_nanoseconds'] || element['_seconds']) {
            const NS_TO_MS_MULTIPLIER = 1 / 1000000;
            const SEC_TO_MS_MULTIPLIER = 1000;
            const timestampInMilliseconds = element['_seconds'] * SEC_TO_MS_MULTIPLIER + element['_nanoseconds'] * NS_TO_MS_MULTIPLIER;
            const date = new Date(timestampInMilliseconds);
            element = date;
            dateValue = date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
            dateValue += ', ' + date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" });
        }
        if (element['nanoseconds'] || element['seconds']) {
            const NS_TO_MS_MULTIPLIER = 1 / 1000000;
            const SEC_TO_MS_MULTIPLIER = 1000;
            const timestampInMilliseconds = element['seconds'] * SEC_TO_MS_MULTIPLIER + element['nanoseconds'] * NS_TO_MS_MULTIPLIER;
            const date = new Date(timestampInMilliseconds);
            element = date;
            dateValue = date.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
            dateValue += ', ' + date.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" });
        }
        try {
            const newdate = new Date(element);
            if (newdate)
                dateValue = newdate.toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' });
            dateValue += ', ' + newdate.toLocaleTimeString('de-DE', { hour: "2-digit", minute: "2-digit" });
        }
        catch (errro) { }
    }
    return dateValue;
};
exports.convertDateTime = convertDateTime;
const dataToObject = function (obj) {
    const data = {};
    Object.entries(obj).forEach(([key, value]) => {
        if (!key.includes('.')) {
            data[key] = value;
            return;
        }
        const parts = key.split('.');
        let current = data;
        parts.forEach((part, index) => {
            if (index === parts.length - 1)
                current[part] = value;
            else {
                if (!current[part])
                    current[part] = {};
                current = current[part];
            }
        });
    });
    return data;
};
exports.dataToObject = dataToObject;
const generateId = function (length) {
    let result = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let counter = 0;
    while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
    }
    return result;
};
exports.generateId = generateId;
const preparePOTtoFirestore = function (poi) {
    const plain = {};
    for (const key of Object.keys(poi)) {
        if (['context', 'className'].includes(key))
            continue;
        const val = poi[key];
        if (val !== undefined)
            plain[key] = val;
    }
    return plain;
};
exports.preparePOTtoFirestore = preparePOTtoFirestore;
